<ng-progress [spinner]="false" [thick]="true" [color]="'#5b70ff'"></ng-progress>

<main id="main-content" class="content">
    <router-outlet></router-outlet>
    <msc-toast></msc-toast>
</main>
